import { TablePaginationProps, TablePagination } from './TablePagination'

type TableFooterProps = {
    pagination: TablePaginationProps
}
export const TableFooter: React.FC<TableFooterProps> = (props) => {
    const { pagination } = props

    return (
        <div className="group/row">
            <div className="rounded-b-xl border-t border-neutral-200 bg-white">
                <TablePagination {...pagination} />
            </div>
        </div>
    )
}
